import { Component, OnInit, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { LoginService } from 'src/app/services/login/login.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { SalesInvoiceComponent } from 'src/app/erp/components/sales-invoice/sales-invoice.component';
import { ExportexcelService } from 'src/app/services/exportexcel/exportexcel.service';
import { ModulemappingService } from 'src/app/erp/services/modulemapping/modulemapping.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  pendingActionsForm: FormGroup;
  changePasswordForm: FormGroup;
  public showToolPanel: boolean = true;

  user: any;
  role: string;
  hide: boolean = true;
  permissions: any = [];
  locations: any = [];
  itemList: any = [];
  selectedLocationId: number | null = null;
  pendingActionsList: any[] = [];
  disableExportBtn = true;
  disableInwrdExportBtn = true;
  exportData: any[] = [];
  display: string;
  pendingInwardsCount: any = 0;
  pendingInwardsList: any[] = [];
  isSidebarOpen: boolean = false;
  isTopbarOpen: boolean = false;
  logoImageBase64: string = '';
  private baseUrl: string = 'https://s3service.sconexsoft.com/s3bucket/presigned-url';
  s3AssetFolder: string = '';
  bucketName: string = '';
  todayDate: string = new Date().toISOString().split('T')[0]; // Today's date in YYYY-MM-DD format

  columnDefs = [
    {
      headerName: '', field: 'actions', width: 60, cellRenderer: (params) => {
        return '<i class="fas fa-edit btn text-primary p-0 ml-2 mr-2" data-action-type="edit" ></i>' +
          '<i class="fas fa-trash-alt btn text-danger p-0" data-action-type="delete"></i>';
      }
    },
    { headerName: 'ActionID', field: 'ActionID', width: 100, hide: true },
    { headerName: 'ActionType', field: 'ActionType', width: 100, resizable: true, filter: true, sortable: true },
    { headerName: 'Action Description', field: 'ActionDescription', width: 400, resizable: true, filter: true, sortable: true },
    { headerName: 'CreateDt', field: 'CreatedDate', width: 100, resizable: true, filter: true, sortable: true },
    { headerName: 'ETA', field: 'Eta', width: 100, resizable: true, filter: true, sortable: true },
    { headerName: 'Status', field: 'Status', width: 100, resizable: true, filter: true, sortable: true },
    { headerName: 'Comment', field: 'Comment', width: 100, resizable: true, filter: true, sortable: true },
    { headerName: 'RequestedBy', field: 'RequestedBy', width: 100, resizable: true, filter: true, sortable: true },
    { headerName: 'AssignedTo', field: 'AssignedTo', width: 100, resizable: true, filter: true, sortable: true },
    { headerName: 'HoursWorked', field: 'HoursWorked', width: 100, resizable: true, filter: true, sortable: true },
  ];

  columnDefsPenInwrds = [
    { headerName: 'SourceLocationID', field: 'SourceLocationID', flex: 1, hide: true },
    { headerName: 'SourceBranch', field: 'SourceBranch', flex: 1, resizable: true, filter: true, sortable: true },
    { headerName: 'OutwardNo.', field: 'SourceOutwardNumber', flex: 1, resizable: true, filter: true, sortable: true, cellStyle: { textAlign: 'right' } },
    { headerName: 'OutwardDisplayNo.', field: 'SourceOutwardDisplayNumber', flex: 1, resizable: true, filter: true, sortable: true },
    { headerName: 'OutwardDt.', field: 'SourceOutwardDate', flex: 1, resizable: true, filter: true, sortable: true },
  ];

  public gridOptions = {
    pagination: true,
    paginationAutoPageSize: true,
    suppressRowClickSelection: true,
    suppressCellSelection: true,
    enableCellTextSelection: true,
    rowData: null
  };

  statusList: any[] = ["New", "In Progress", "Pending", "Completed"];
  actionTypeList: any[] = ["Change Request", "Issue", "Data Correction"];
  priorityList: any[] = ["P1", "P2", "P3", "P4"];
  moduleList: any[] = ["Accounts", "Admin", "Analitics", "Business", "HRMS", "Sales & Distribution", "Service"];

  @ViewChild(SalesInvoiceComponent) salesInvoiceComponent: SalesInvoiceComponent;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private datePipe: DatePipe,
    private loginService: LoginService,
    private excelService: ExportexcelService,
    private moduleMappingService: ModulemappingService,
    private route: Router,
    private http: HttpClient
  ) {
    this.pendingActionsForm = this.fb.group({
      RequestType: "ADD",
      ActionID: [0, Validators.required],
      ActionDescription: ['', Validators.required],
      Eta: [null, [Validators.required, this.futureDateValidator]],
      CreatedDate: [null],
      UpdatedDate: [null],
      ModuleName: [null, Validators.required],
      Priority: [null, Validators.required],
      Status: [null, Validators.required],
      Comment: ['', Validators.required],
      RequestedBy: ['', Validators.required],
      HoursWorked: ['', [Validators.required, Validators.min(1)]],
      AssignedTo: ['', Validators.required],
      ActionType: [null, Validators.required],
      CreateUserID: ''
    });
    this.changePasswordForm = this.fb.group({
      CurrentPassword: [null, Validators.required],
      NewPassword: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(12)]],
      ConfirmPassword: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(12)]],
      CreateUserID: '',
      EmployeeID: '',
      EmployeeCode: '',
      LocationID: 0
    });
  }

  showChangePasswordForm: boolean = true;
  showChangePasswordMsg: boolean = false;

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.role = JSON.parse(localStorage.getItem('role'));
    this.permissions = JSON.parse(localStorage.getItem('permissions'));
    this.selectedLocationId = this.user?.LocationID || null;
    this.getLocationCodes();
    this.resetPasswordFrom();
    this.showChangePasswordForm = true;
    this.showChangePasswordMsg = false;
    this.getPendingInwardsCount();
  }

  async fetchLogoImage() {
    if (!this.s3AssetFolder || !this.bucketName) {
      console.error('Missing S3AssetFolder or S3BucketName', {
        s3AssetFolder: this.s3AssetFolder,
        bucketName: this.bucketName
      });
      this.logoImageBase64 = '';
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'S3 configuration missing. Please ensure S3BucketName is provided for the selected location.'
      });
      return;
    }

    const cleanFolder = this.s3AssetFolder.replace(/^\/+/, '');
    const fileName = `${cleanFolder}Logo.jpeg`.replace(/\/+/g, '/');
    const apiUrl = `${this.baseUrl}?fileName=${encodeURIComponent(fileName)}&bucketName=${encodeURIComponent(this.bucketName)}&operation=download`;

    await this.http.get(apiUrl, { responseType: 'text' }).subscribe(
      (presignedUrl: string) => {
        if (!presignedUrl.startsWith('https://')) {
          console.error('Invalid presigned URL:', presignedUrl);
          this.logoImageBase64 = '';
          return;
        }
        this.http.get(presignedUrl, { responseType: 'blob' }).subscribe(
          (blob: Blob) => {
            if (blob.type !== 'image/jpeg') {
              console.error('Fetched blob is not a JPEG image:', blob.type);
              this.logoImageBase64 = '';
              return;
            }
            const reader = new FileReader();
            reader.onloadend = () => {
              this.logoImageBase64 = reader.result as string;
            };
            reader.onerror = (error) => {
              console.error('FileReader error:', error);
              this.logoImageBase64 = '';
            };
            reader.readAsDataURL(blob);
          },
          (error) => {
            console.error('Error fetching image from presigned URL:', error, {
              status: error.status,
              statusText: error.statusText,
              url: presignedUrl
            });
            this.logoImageBase64 = '';
          }
        );
      },
      (error) => {
        console.error('Error fetching presigned URL:', error, {
          status: error.status,
          statusText: error.statusText,
          url: apiUrl
        });
        this.logoImageBase64 = '';
      }
    );
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
    const sidebar = document.getElementById('collapse');
    if (sidebar) {
      sidebar.classList.toggle('show', this.isSidebarOpen);
    }
  }

  toggleTopbar() {
    this.isTopbarOpen = !this.isTopbarOpen;
    const topbar = document.querySelector('.navbar-collapse');
    if (topbar) {
      topbar.classList.toggle('show', this.isTopbarOpen);
    }
  }

  clearPasswordFrom() {}

  getModules() {
    this.moduleMappingService.getModules().subscribe(res => {
      this.moduleList = [];
      this.moduleList = res.body;
    });
  }

  getPendingInwardsCount() {
    let locationId = this.user.LocationID;
    this.loginService.getPendingInwardsCount(this.user.LocationID).subscribe(res => {
      this.pendingInwardsCount = res.Count;
    });
  }

  getPendingInwards() {
    this.disableInwrdExportBtn = true;
    this.exportData = [];
    let locationId = this.user.LocationID;
    this.loginService.getPendingInwards(this.user.LocationID).subscribe(res => {
      this.pendingInwardsList = res.balanceOutwardHeaders;
      this.pendingInwardsList.map(element => element.SourceOutwardDate = this.datePipe.transform(element.SourceOutwardDate, 'dd-MMM-yyyy'));
      this.pendingInwardsList.forEach(element => {
        let obj = {
          SourceBranch: element.SourceBranch,
          OutwardNo: element.SourceOutwardNumber,
          OutwardDisplayNo: element.SourceOutwardDisplayNumber,
          OutwardDt: element.SourceOutwardDate,
        };
        this.exportData.push(obj);
      });
      if (this.pendingInwardsList.length > 0) {
        this.disableInwrdExportBtn = false;
      }
    });
  }

  openChangePasswordForm() {
    this.display = 'block';
  }

  myFunction() {
    this.toggleSidebar();
  }

  onCloseHandled() {
    this.isSidebarOpen = false;
    this.isTopbarOpen = false;
    const sidebar = document.getElementById('collapse');
    const topbar = document.querySelector('.navbar-collapse');
    if (sidebar) {
      sidebar.classList.remove('show');
    }
    if (topbar) {
      topbar.classList.remove('show');
    }
  }

  savePassword() {
    if (!this.changePasswordForm.valid) {
      return;
    }
    let currentPassword = this.changePasswordForm.value.CurrentPassword;
    let newPassword = this.changePasswordForm.value.NewPassword;
    let confirmPassword = this.changePasswordForm.value.ConfirmPassword;

    if (currentPassword === confirmPassword) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'New Password and Current Password should not be same'
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'New Password and Confirm Password should match'
      });
      return;
    }

    this.loginService.savePassword(this.changePasswordForm.value).subscribe(res => {
      if (res.status === 201) {
        this.resetPasswordFrom();
        this.showChangePasswordForm = false;
        this.showChangePasswordMsg = true;
      }
    });
  }

  resetPasswordFrom() {
    this.changePasswordForm = this.fb.group({
      CurrentPassword: [null, Validators.required],
      NewPassword: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(12)]],
      ConfirmPassword: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(12)]],
      CreateUserID: this.user.EmployeeCode,
      EmployeeID: this.user.EmployeeID,
      EmployeeCode: this.user.EmployeeCode,
      LocationID: this.user.LocationID
    });
  }

  getActionItems() {
    this.exportData = [];
    this.loginService.getPendingActions().subscribe(res => {
      this.pendingActionsList = res;
      this.pendingActionsList.map(element => {
        element.CreatedDate = this.datePipe.transform(element.CreatedDate, 'dd-MMM-yyyy');
        element.UpdatedDate = this.datePipe.transform(element.UpdatedDate, 'dd-MMM-yyyy');
        element.Eta = this.datePipe.transform(element.Eta, 'dd-MMM-yyyy');
      });
      if (this.pendingActionsList.length > 0) {
        this.pendingActionsList.forEach(element => {
          let obj = {
            ActionType: element.ActionType,
            ActionDescription: element.ActionDescription,
            ModuleName: element.ModuleName,
            Priority: element.Priority,
            CreatedDate: element.CreatedDate,
            UpdatedDate: element.UpdatedDate,
            Eta: element.Eta,
            Status: element.Status,
            Comment: element.Comment,
            RequestedBy: element.RequestedBy,
            AssignedTo: element.AssignedTo,
            HoursWorked: element.HoursWorked,
          };
          this.exportData.push(obj);
        });
        this.disableExportBtn = false;
      }
      this.setActionItemDefaultValues();
    });
  }

  saveActionItems() {
    this.pendingActionsForm.patchValue({ CreateUserID: this.user.EmployeeCode });
    if (this.pendingActionsForm.invalid) {
      return false;
    }
    this.loginService.savePendingActions(this.pendingActionsForm.value).subscribe(res => {
      if (res.status === 201) {
        if (this.pendingActionsForm.value.RequestType == "ADD") {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Action item saved successfully'
          });
        } else if (this.pendingActionsForm.value.RequestType == "UPDATE") {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Action item updated successfully'
          });
        } else if (this.pendingActionsForm.value.RequestType == "DELETE") {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Action item deleted successfully'
          });
        }
        this.getActionItems();
      }
    });
  }

  setActionItemDefaultValues() {
    this.pendingActionsForm = this.fb.group({
      RequestType: "ADD",
      ActionID: [0, Validators.required],
      ActionDescription: ['', Validators.required],
      Eta: [null, [Validators.required, this.futureDateValidator]],
      CreatedDate: [null],
      UpdatedDate: [null],
      ModuleName: [null, Validators.required],
      Priority: [null, Validators.required],
      Status: [null, Validators.required],
      Comment: ['', Validators.required],
      RequestedBy: ['', Validators.required],
      HoursWorked: ['', [Validators.required, Validators.min(1)]],
      AssignedTo: ['', Validators.required],
      ActionType: [null, Validators.required],
      CreateUserID: this.user.EmployeeCode
    });
  }

  exportExel() {
    this.excelService.exportAsExcelFile(this.exportData, 'pending_actions_list');
  }

  exportPendingInwardsExel() {
    this.excelService.exportAsExcelFile(this.exportData, 'pending_inwards_list');
  }

  EditFill(rowData) {
    this.pendingActionsForm = this.fb.group({
      RequestType: "UPDATE",
      ActionID: [rowData.data.ActionID, Validators.required],
      ActionDescription: [rowData.data.ActionDescription, Validators.required],
      Eta: [this.datePipe.transform(rowData.data.Eta, "yyyy-MM-dd"), [Validators.required, this.futureDateValidator]],
      CreatedDate: [this.datePipe.transform(rowData.data.CreatedDate, "yyyy-MM-dd")],
      UpdatedDate: [this.datePipe.transform(rowData.data.UpdatedDate, "yyyy-MM-dd")],
      ModuleName: [rowData.data.ModuleName, Validators.required],
      Priority: [rowData.data.Priority, Validators.required],
      Status: [rowData.data.Status, Validators.required],
      Comment: [rowData.data.Comment, Validators.required],
      RequestedBy: [rowData.data.RequestedBy, Validators.required],
      AssignedTo: [rowData.data.AssignedTo, Validators.required],
      ActionType: [rowData.data.ActionType, Validators.required],
      HoursWorked: [rowData.data.HoursWorked, [Validators.required, Validators.min(1)]],
      CreateUserID: this.user.EmployeeCode
    });
  }

  onRowClicked(e) {
    if (e.event.target !== undefined) {
      const data = e.data;
      const actionType = e.event.target.getAttribute('data-action-type');

      switch (actionType) {
        case 'edit':
          return this.EditFill(e);
        case 'delete':
          return this.deleteActionItem(data);
      }
    }
  }

  deleteActionItem(data: any) {
    this.pendingActionsForm = this.fb.group({
      RequestType: "DELETE",
      ActionID: data.ActionID,
      ActionDescription: [data.ActionDescription, Validators.required],
      Eta: [data.Eta, [Validators.required, this.futureDateValidator]],
      Status: [data.Status, Validators.required],
      Comment: [data.Comment, Validators.required],
      RequestedBy: [data.RequestedBy, Validators.required],
      CreateUserID: this.user.EmployeeCode
    });
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.saveActionItems();
      } else {
        this.setActionItemDefaultValues();
      }
    });
  }

  redirectHome() {
    this.router.navigate(['/home']);
  }

  getLocationCodes() {
    this.loginService.getLocationCodes().subscribe({
      next: (res) => {
        this.itemList = [];
        this.locations = res.map(item => ({
          ID: item.LocationID,
          Code: item.Name,
          S3AssetFolder: item.S3AssetFolder || '',
          S3BucketName: item.S3BucketName || ''
        }));

        // Set initial location from user data
        if (this.selectedLocationId) {
          const selectedLocation = this.locations.find(loc => loc.ID === Number(this.selectedLocationId));
          if (selectedLocation) {
            this.s3AssetFolder = selectedLocation.S3AssetFolder;
            this.bucketName = selectedLocation.S3BucketName;
            this.fetchLogoImage();
          } else {
            this.logoImageBase64 = '';
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Selected location not found'
            });
          }
        }
      },
      error: (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch location codes: ' + (error.message || 'Unknown error')
        });
        this.logoImageBase64 = '';
      }
    });
  }

  logout() {
    let userData = {
      LocationID: this.user.LocationID,
      EmployeeCode: this.user.EmployeeCode
    };
    this.loginService.updateLogoutStatus(userData).subscribe(res => {
      
    });
    this.loginService.logout();
  }

  futureDateValidator(control: any) {
    if (!control.value) return null;
    
    const selectedDate = new Date(control.value);
    const today = new Date();
    
    // Set both dates to midnight to compare only the date part
    selectedDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    
    if (selectedDate < today) {
      return { invalidDate: true };
    }
    return null;
  }
}